import { AnalyticsStore, RouteStore } from 'bernie-core';

import { onClickScrollToTarget } from 'utils/smooth-scroll';

let gssDialog;

interface SearchOptionStructure {
  name?: string;
  value?: string;
}

export const openAuthWindow = (url, width, height) => {
  const left = window.top.outerWidth / 2 + window.top.screenX - width / 2;
  const top = window.top.outerHeight / 2 + window.top.screenY - height / 2;

  return window.open(
    decodeURIComponent(url),
    'GSSAuthWindow',
    `copyhistory=no,toolbar=no,menubar=no,location=no,status=no,directories=no,
    width=${width},height=${height},top=${top},left=${left}`
  );
};

export const handleSignInSignUpClick = (
  event,
  analytics: AnalyticsStore,
  routeStore: RouteStore,
  eventMetadata: string,
  searchOption: SearchOptionStructure
): void => {
  event.preventDefault();
  if (gssDialog && gssDialog.closed === false) {
    gssDialog.focus();
  } else {
    window.userAuthenticated = undefined;
    gssDialog = openAuthWindow(event.target.href, 400, 520);
    if (gssDialog) {
      gssDialog.focus();
      analytics.trackEvent('GSS.Dialog.Window.Open', 'GSS dialog window opened', null, null, true);
      const timer = setInterval(() => {
        if (gssDialog.closed) {
          clearInterval(timer);
          if (getGSSDialogAuthResponse()) {
            if (searchOption && searchOption.name && searchOption.value) {
              updateSearchAndScroll(analytics, routeStore, searchOption);
            }
            refreshUserSession();
          } else {
            analytics.trackEvent('GSS.window.popup.cancelled', 'GSS dialog window cancelled', null, null, true);
          }
        }
      }, 100);
    } else {
      analytics.trackEvent('GSS.window.popup.blocked', 'Browser window popup blocked', null, null, true);
      window.location.assign(event.target.href);
    }
  }
};

export const getGSSDialogAuthResponse = () => {
  let isUserAuthenticated;
  if (Storage) {
    isUserAuthenticated = localStorage.getItem('userAuthenticated');
    localStorage.removeItem('userAuthenticated');
  } else {
    isUserAuthenticated = window.userAuthenticated;
  }
  try {
    return JSON.parse(isUserAuthenticated);
  } catch (e) {
    return null;
  }
};

export const refreshUserSession = () => {
  window.location.reload();
};

export const updateSearchAndScroll = (analytics: AnalyticsStore, routeStore: RouteStore, searchOption: SearchOptionStructure): void => {
  const { name, value } = searchOption;
  if (routeStore && typeof routeStore.updateSearch === 'function') {
    routeStore.updateSearch(`${name}=${value}`);
    scrollToPageTop();

    analytics.trackEvent('Mod.Sign.In.Pin', 'Mod Sign In updated search', null, null, true);
  }
};

export const scrollToPageTop = () => {
  onClickScrollToTarget({ scrollTo: 0 });
};
